module.exports = __webpack_public_path__ + "static/media/male_head.bfbcb2ca.jpg";